import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { usePermissions } from '../contexts/PermissionsContext';
import { getUserHighestRole } from '../utils/roleHelpers';
import './ProtectedRoute.css';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading: authLoading } = useAuth();
  const { roles, loading: rolesLoading, activeRole } = usePermissions();

  // Show loading state
  if (authLoading || rolesLoading) {
    return (
      <div className="loading-container">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // If no specific roles are required, allow access
  if (allowedRoles.length === 0) {
    return children;
  }

  // If roles are still loading (not in loading state but roles array is empty/undefined), wait
  if (!roles || (Array.isArray(roles) && roles.length === 0)) {
    console.log('ProtectedRoute: Roles still loading, showing loading state');
    return (
      <div className="loading-container">
        <div className="loading">Loading roles...</div>
      </div>
    );
  }

  // Use getUserHighestRole for debugging
  const highestRole = getUserHighestRole(roles);
  console.log('ProtectedRoute: User highest role:', highestRole);

  // Use activeRole for route guard
  console.log('ProtectedRoute Debug:', {
    allowedRoles,
    activeRole,
    roles,
    hasRoles: !!roles,
    rolesLength: roles?.length || 0
  });

  // Only allow access if activeRole is in allowedRoles
  const hasRequiredRole = allowedRoles.includes(activeRole);

  if (!hasRequiredRole) {
    console.log(`Access denied. Active role: ${activeRole}, Required roles: ${allowedRoles.join(', ')}`);
    // Redirect to their appropriate dashboard
    return <Navigate to={`/app/home`} replace />;
  }

  console.log('ProtectedRoute: Access granted!');
  return children;
};

export default ProtectedRoute; 